import HomeActionTypes from './home.types';
// Set the reducers initial state.
const INITIAL_STATE = {
    initialSynced: false,
    syncinghome: false,
    message: null
}

// Define scenarios for reducers.
const homeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HomeActionTypes.HOME_SYNC_START:
            return {
                ...state,
                syncinghome: true
            };
        case HomeActionTypes.HOME_SYNC_FINISH:
            return {
                ...state,
                initialSynced: action.payload.initialSynced,
                syncinghome: action.payload.syncinghome,
                bannerList: action.payload.bannerList,
                message: action.payload.message,
            };
        default:
            return state
    }
}

export default homeReducer;